import { render, staticRenderFns } from "./PagesList.vue?vue&type=template&id=f998293a"
import script from "./PagesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./PagesList.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports